import "./actor.cb50ae3a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6TXE3 = parcelRequire("6TXE3");
var $57bfa0dc40c3586b$exports = {};
$57bfa0dc40c3586b$exports = import.meta.resolve("1aTba");


// start-snippet{displaymode.fitscreen}
const $96ec38f3b1b0cd7a$var$game = new $6TXE3.Engine({
    width: 600,
    height: 400,
    displayMode: $6TXE3.DisplayMode.FitScreen // highlight-line
});
// end-snippet{displaymode.fitscreen}
const $96ec38f3b1b0cd7a$var$playerImage = new $6TXE3.ImageSource((0, (/*@__PURE__*/$parcel$interopDefault($57bfa0dc40c3586b$exports))));
const $96ec38f3b1b0cd7a$var$loader = new $6TXE3.Loader([
    $96ec38f3b1b0cd7a$var$playerImage
]);
$96ec38f3b1b0cd7a$var$game.start($96ec38f3b1b0cd7a$var$loader).then(()=>{
    const actor = new $6TXE3.Actor({
        pos: $96ec38f3b1b0cd7a$var$game.screen.center
    });
    actor.graphics.use($96ec38f3b1b0cd7a$var$playerImage.toSprite());
    $96ec38f3b1b0cd7a$var$game.currentScene.add(actor);
});


//# sourceMappingURL=fitscreen.2b3b5478.js.map
